export { default as Header } from './Header'
export { default as Hero } from './Hero'
export { default as FeaturesStrip } from './FeatureStrip'
export { default as MobileShowcase } from './MobileShowCase'
export { default as HowItWorks } from './HowItWorks'
export { default as UseCaseCTA } from './UseCaseCTA'
export { default as Footer } from './Footer'
